module.exports = __webpack_public_path__ + "assets/img/chronicleImgActive-a09c7ed6.png";